/**
 * Created by Languagenut on 22/03/2019.
 */


import React  from 'react';
import {Breadcrumb , Navbar , Card , Row , Col , Nav , NavDropdown,Modal} from 'react-bootstrap'
import { Overview, Teacher , Assignments , Lessons , Members , Grading ,  Reports} from '../components/classes';
import {ClassesService} from '../services';
import {ClassesStore , ProductStore , AccountStore} from '../store';
import Constants from '../constants.js';
import {RecentActivity} from '../components/reports';
import TextPopup from '../components/popup/text_popup.js';
import SelectMultiplePopup from '../components/popup/select_multiple_popup.js';
import Translation from '../store/internationalization-store.js';
import Comfirmation from '../components/popup/comfirmation_popup.js';
import ProductServices from '../services/product-service.js';
import AccountService from '../services/account-service.js'
import UpdateCurriculumSettings from '../components/settings.js'
import LanguagenutPackage from '../classes/package.js';
import Highscore from '../components/reports/highscores.js'
import Popup from '../components/popup/comfirmation_popup.js'
import FieldGroup from '../components/FieldGroup.js';
import CreateStudent from '../components/popup/new_student.js'

export default class Authentication extends React.Component {


    constructor(props) {
        super();
        this.props = props;
        this.displayLimit = 5;

        this.state = {
            "tab":this.props.match.params.tab,
            "classUID":this.props.match.params.id,
            "className":"",
            "teachers":[],
            "languages":ProductStore.getLearningLanguages(),
            "staff":[],
            "studentsData":[]
        };
    }

    hasSelectedClassChanged(newClassUID){
        return this.state.classUID != newClassUID;
    }

    componentWillMount() {

        ProductStore.on(Constants.GET_LANGUAGES , ()=>{

            this.setState({
                "languages":ProductStore.getLearningLanguages(),
            });
        });


        AccountStore.on(Constants.GET_ACCOUNT_STAFF , ()=>{
            this.setState({
                staff:AccountStore.staff || [],
            })
        });

        AccountStore.on(Constants.GET_ACCOUNT_STUDENTS , ()=>{
            this.setState({
                studentsData:AccountStore.students || [],
            })
        });

        ClassesStore.on(Constants.GET_CLASS_DATA ,  ()=>{
            var data = ClassesStore.getLastClass();

            let l = ProductStore.getLearningLanguages();
            let languages = (data.languages || []).map(function(object , index){

                var getLabel = function(ietf){
                    for(var i = 0 ; i < l.length; i++ )
                    {
                        if(l[i].ietf == ietf) return l[i].name
                    }

                    return 0
                }


                return {label:Translation.get(getLabel(object) , 'Unkown') , value:object}
            }.bind(this))

            console.log(data)

            this.setState({
                "className":data.className,
                "teachers":data.teachers,
                "classLanguages":languages,
                "hideHints":data.hideHints,
            });
        })
    }

    componentDidMount() {
        ProductServices.getAllLanguages().then(ClassesService.getClass.bind(this , this.state.classUID))
        AccountService.getMembers()
        AccountService.getStudents()

    }

    removeClass(){
        ClassesService.delete(this.state.classUID).then(function(){
            window.location.hash = "class/management"
        })
    }

    updateName(name){


        this.setState({
            className:name
        });


        ClassesService.doesNameExist(name).then(function(response){

            if(response)
            {
                ClassesService.updateName(name , this.state.classUID)
            }


        }.bind(this));

    }

    componentWillReceiveProps(props){
        this.props = props;

        if(this.hasSelectedClassChanged(this.props.match.params.id))
        {
            console.log("class-swap");
        }

        this.props = props;

        this.setState({
            "tab":this.props.match.params.tab,
            "classUID":this.props.match.params.id
        });

    }

    handleSelect(eventKey) {
        window.location.hash = "classes/"+eventKey+'/'+this.state.classUID
    }

    getBody(){

        switch(this.state.tab)
        {
            case "news":return <RecentActivity classID={this.props.match.params.id}/>;
            case "overview":return <Overview languages={this.state.classLanguages} classID={this.props.match.params.id}/>;
            case "students" : return <Members action={this.props.match.params.action} name={this.state.className} classID={this.props.match.params.id}/>
            case "teachers" : return <Teacher classID={this.props.match.params.id} />
            case "lessons" : return <Lessons classID={this.props.match.params.id}/>
            case "highscores" :return <Highscore classID={this.props.match.params.id} />
            case "grading" : return <Grading classID={this.props.match.params.id}/>
            case "reports" : return <Reports classLanguages={this.state.classLanguages} screenID={this.props.match.params.screenID} language={this.props.match.params.language} classID={this.props.match.params.id} selectedReport={this.props.match.params.reportID}/>
            case "assignments" : return <Assignments classID={this.props.match.params.id}/>
            default : return <h1>{Translation.get(12735, "No tab selected")}</h1>
        }

    }

    getBreadCrumb(){

        switch(this.state.tab)
        {
            case "news":return Translation.get(12736 , 'News')
            case "overview":return Translation.get(2216 , 'Overview');
            case "students" :return Translation.get(29 , 'Students');
            case "teachers" :return Translation.get(4 , 'Teacher');
            case "lessons" : return Translation.get(12737 , 'Lessons');
            case "reports" : return Translation.get(12738 , 'Reports');
            case "highscores" : return Translation.get(12625 , 'High scores');
            case "assignments" : return Translation.get(12052 , 'Assignments');
            case "grading" : return Translation.get(12739 , 'Grading');
            default : return 'error';
        }

    }

    shouldHide(){

        if(this.props.match.params.reportID)
        {
            return true;
        }

        return false;
    }

    updateStaff(teachers){

        ClassesService.updateTeachers(teachers , this.state.classUID);

        this.setState({
            teachers:teachers
        })
    }

    updateStudents(students){
      
        ClassesService.updateAddStudents(students , this.state.classUID).then(function() {
            ClassesService.getStudents(this.state.classUID)
        }.bind(this));

        this.setState({
            update:true
        })
    }

    updateClassLanguages(languages){


        let send = languages.map(function(object , index){
            return object.value
        }.bind(this))

        ClassesService.updateLanguages(send , this.state.classUID);

        this.setState({
            classLanguages:languages
        })
    }

    updateHints(){

        let hints = this.state.hideHints == '0' ? '1' : '0'

        this.setState({
            hideHints:hints
        });

        ClassesService.updateHints(this.state.classUID , hints)
    }

    closeClassCurriculum() {
        this.setState({showClassCurriculum:false});
    }


    render(){
        let close = ()=>{ this.setState({modifyName:false})};
        let _delete = ()=>{ this.setState({comfirmation:false})};
        let _open = ()=>{ this.setState({comfirmation:false})};

        let languages = this.state.languages.map(function(object , index){
            return {label: Translation.get(object.name , 'Unkown'),value: object.ietf};
        }.bind(this));


        let staff = this.state.staff.map(function(object , index){

            //ShortTermLending@financial-ombudsman.org.uk


            return {label:object.name ,value: object.uid};
        }.bind(this));

        let students = this.state.studentsData.map(function(object , index){

            //ShortTermLending@financial-ombudsman.org.uk


            return {label:object.name ,value: object.uid};
        }.bind(this));


        let teacher_graded = null;


        if((new LanguagenutPackage()).isSecondary())
        {
            teacher_graded = <Nav.Item disabled>
                <Nav.Link eventKey="grading">{Translation.get(12747 , 'Teacher-Graded')}</Nav.Link>
            </Nav.Item>
        }

        var popup = <Popup oneButton={true} buttonTitle={Translation.get(12787, "Send")} title={this.state.className + ": " + Translation.get(12789, "Class Message")} 
                onSave={()=>{
                    AccountService.createMessageClass(this.state.messageTitle, this.state.messageMessage, this.state.classUID)
                    this.setState({addMessage:false});
                }} 
                onHide={()=>{
                    this.setState({addMessage:false});
                }} 
                show={this.state.addMessage} 
                body={<div>
                        <Row >
                            <Col sm={{span: 12}}>
                                <FieldGroup value={this.state.messageTitle} 
                                        onSelect={(event)=>{
                                            this.setState({lastSelected:event.target, lastSelectType:"title", lastPosition:undefined});
                                        }} 
                                        onChange={(event)=>{ this.setState({messageTitle:event.target.value}) }} 
                                        className="strong" as="input" label={Translation.get(2202, 'Title')}  type="input" autofocus="true"/>
                            </Col>
                        </Row>
                        <Row >
                            <Col sm={{span: 12}}>
                                <FieldGroup value={this.state.messageMessage} 
                                            onSelect={(event)=>{
                                                this.setState({lastSelected:event.target, lastSelectType:"message", lastPosition:undefined});
                                            }} 
                                            onChange={(event)=>{ this.setState({messageMessage:event.target.value}) }} 
                                            className="strong" as="input" label={Translation.get(12778, 'Subject')}  type="input" as="textarea" rows="3" />
                            </Col>
                        </Row>
                        {AccountService.getEmojiData(this)}
                    </div>} />


        var classContent = <Modal
            show={this.state.showClassCurriculum}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            onHide={()=>{ this.setState({showClassCurriculum:false})}}
            >
        <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
                {Translation.get(12740 , 'Add Additional Vocab')}
            </Modal.Title>
        </Modal.Header>
        <UpdateCurriculumSettings classUid={this.state.classUID} onSave={this.closeClassCurriculum.bind(this)}/>
        </Modal>
        return <div >
            {classContent}
            <CreateStudent classID={this.state.classUID} show={this.state.createShow} onHide={()=>{ this.setState({createShow:false})}} />
            <Comfirmation onSave={this.updateHints.bind(this)} body={this.state.hideHints == '0' ? Translation.get(12741 , 'Are you sure you want to remove vocabulary hints for this class?') : Translation.get(12769 , 'Are you sure you want to activate vocabulary hints for this class?')} onHide={()=>{ this.setState({hints_comfirmation:false})}} show={this.state.hints_comfirmation} />
            <Comfirmation onSave={this.removeClass.bind(this)} body={Translation.get(12742 , 'Are you sure you want to delete this class?')} onHide={_delete} show={this.state.comfirmation} />
            <TextPopup onSave={this.updateName.bind(this)} value={this.state.className} title={ Translation.get(347 , "Edit Class Name")} fieldTitle={Translation.get(819 , "Class Name")} onHide={close} show={this.state.modifyName}/>
            <SelectMultiplePopup value={this.state.teachers || []} onSave={this.updateStaff.bind(this)} data={staff} title={Translation.get(12743, 'Edit Teacher Access')} fieldTitle="Select Teachers" onHide={ ()=>{ this.setState({modifyTeachers:false})}} show={this.state.modifyTeachers}/>
            <SelectMultiplePopup value={this.state.students || []} onSave={this.updateStudents.bind(this)} data={students} 
                    title={Translation.get(12744 , 'Add Existing Students to Class')} fieldTitle="Select Students" onHide={ ()=>{ this.setState({addStudents:false})}} 
                    show={this.state.addStudents} />
            {popup}
            <SelectMultiplePopup value={this.state.classLanguages || []} onSave={this.updateClassLanguages.bind(this)} data={languages} title={Translation.get(12745 , 'Choose Languages')} fieldTitle={Translation.get(12188 , 'Languages')}  onHide={ ()=>{ this.setState({modifyLanguages:false})}} show={this.state.modifyLanguages}/>
                <Row>
                    <Col sm={12} md={12}>
                        <Breadcrumb>
                            <Breadcrumb.Item href="#/class/management">{Translation.get(782 , 'Class Management')}</Breadcrumb.Item>
                            <Breadcrumb.Item active>{this.state.className}</Breadcrumb.Item>
                            <Breadcrumb.Item active>{this.getBreadCrumb()}</Breadcrumb.Item>
                        </Breadcrumb>
                        <Card >
                            <Card.Body>
                                <Row>
                                    <Col md={12}>
                                        <Card.Title>{Translation.get(819 , 'Class Name')}: {this.state.className}</Card.Title>
                                        <Card.Subtitle className="mb-2 text-muted">{Translation.get(858, 'Teachers')}: {this.state.teachers.map(function(object , index){

                                            let token = index > 0 ? ' , ' : ' ';

                                            return token + object.label
                                        }.bind(this))}</Card.Subtitle>
                                    </Col>

                                </Row>
                                <hr/>
                                <Navbar style={{padding:0}}>
                                    <Nav defaultActiveKey={this.state.tab} onSelect={k => this.handleSelect(k)}>
                                        <Nav.Item>
                                            <Nav.Link style={{paddingLeft:"0"}} eventKey="overview">{Translation.get(2216 , 'Overview')}</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link style={{paddingLeft:"0"}} eventKey="news">{Translation.get(814 , 'Recent Activity')}</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="students">{Translation.get(29 , 'Students')}</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="teachers">{Translation.get(858, 'Teachers')}</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="highscores">{Translation.get(12625 , 'High Scores')}</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="reports">{Translation.get(12738 , 'Reports')}</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="assignments">{Translation.get(12052 , 'Assignments')}</Nav.Link>
                                        </Nav.Item>
                                        {teacher_graded}
                                    </Nav>
                                    <Navbar.Collapse className="justify-content-end">
                                        <NavDropdown drop={"down"} title={Translation.get(906, ' Settings')} id="basic-nav-dropdown">
                                            <NavDropdown.Item onClick={()=>{ this.setState({modifyName:true})}}>{Translation.get(12748 , 'Modify Name')}</NavDropdown.Item>
                                            <NavDropdown.Item onClick={ ()=>{ this.setState({modifyLanguages:true})}}>{Translation.get(12749 , 'Modify Languages')}</NavDropdown.Item>
                                            <NavDropdown.Item onClick={ ()=>{ this.setState({modifyTeachers:true})}}>{Translation.get(12750 , 'Modify Staff Members')}</NavDropdown.Item>
                                            <NavDropdown.Item onClick={ ()=>{ this.setState({createShow:true})}}>{Translation.get(12729 , 'New Student')}</NavDropdown.Item>
                                            <NavDropdown.Item onClick={ ()=>{ this.setState({addStudents:true, students:[]})}}>{Translation.get(12751 , 'Add Existing Students')}</NavDropdown.Item>
                                            <NavDropdown.Item onClick={ ()=>{ this.setState({addMessage:true, messageMessage:"", messageTitle:""})}}>{Translation.get(2443, 'Add Class Message')}</NavDropdown.Item>
                                            <NavDropdown.Divider />
                                            <NavDropdown.Item onClick={ ()=>{ this.setState({comfirmation:true})}}>{Translation.get(444 , 'Delete')}</NavDropdown.Item>
                                        </NavDropdown>
                                    </Navbar.Collapse>
                                </Navbar>
                            </Card.Body>
                        </Card>
                        <br/>
                        <Card >
                            <Card.Body>
                                {this.getBody()}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
        </div>
    }


}